<template>
    <v-container fluid fill-height class="console-notification">
        <v-layout justify-center>
            <v-responsive max-width="1280px" width="100%">
                <v-row class="mt-8" justify="center" align="center">
                    <v-col cols="auto" class="pt-0 pb-0 headline text-start">공지사항</v-col>
                    <v-spacer></v-spacer>
                    <!-- <v-col cols="auto" class="pt-0 pb-0">
                        <v-btn class="ma-2" color="secondary" rounded @click="showsSearch = !showsSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                    </v-col> -->
                </v-row>

                <v-data-table :headers="notificationsHeaders" :items="notifications" v-bind="{ loading }" disable-sort disable-pagination hide-default-footer class="mt-4 v-sheet--outlined">
                    <template #[`item.notification`]="{ item }" style="height: auto">
                        <v-row @click="$set(item, 'show', !item.show)">
                            <v-col cols="auto" class="text-start">{{ item.subject }}</v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto">
                                <v-icon v-if="!item.show">mdi-chevron-down</v-icon>
                                <v-icon v-else>mdi-chevron-up</v-icon>
                            </v-col>
                        </v-row>
                        <v-expand-transition>
                            <v-row v-show="item.show">
                                <v-col cols="12" class="text-start">
                                    <p v-html="item.content.replace(/\n/g, '<br>')"></p>
                                </v-col>
                            </v-row>
                        </v-expand-transition>
                    </template>
                    <!-- <template #[`item.sites`]="{ item }">
                        <notification-sites :notification="item" />
                    </template> -->
                    <template #[`item.isNotice`]="{ item }">
                        <v-switch v-model="item.isNotice" class="mt-0" hide-details @change="toggleNotice(item)"></v-switch>
                    </template>
                    <template #[`item.createdAt`]="{ item }">
                        {{ item.createdAt.toDate() }}
                    </template>
                    <template #[`item.actions`]="{ item }">
                        <notification-form :value="item" @input="search">
                            <template #activator="{ attrs, on }">
                                <v-icon small class="mr-2" v-bind="attrs" v-on="on"> mdi-pencil </v-icon>
                            </template>
                        </notification-form>
                        <v-icon small @click="remove(item)"> mdi-delete </v-icon>
                    </template>
                </v-data-table>
                <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12" @input="$router.push({ query: { ...$route.query, page } })"></v-pagination>
                <v-fade-transition>
                    <v-overlay v-show="loading">
                        <v-progress-circular indeterminate size="100" width="5" />
                    </v-overlay>
                </v-fade-transition>

                <notification-form :site="site" @input="search">
                    <template #activator="{ attrs, on }">
                        <v-btn v-bind="attrs" v-on="on" bottom color="accent" dark fab fixed right>
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                </notification-form>
            </v-responsive>
        </v-layout>
    </v-container>
</template>

<script>
import api from "@/api";

import NotificationSites from "@/components/console/center/notification-sites.vue";
import NotificationForm from "@/components/console/center/notifications/notification-form.vue";

export default {
    components: {
        NotificationSites,
        NotificationForm,
    },
    name: "Notifications",
    data() {
        return {
            showsSearch: false,
            loading: false,

            page: +(this.$route?.query?.page || 1),
            pageCount: 0,
            limit: 10,

            notifications: [],
            notificationsHeaders: [
                {
                    text: "no",
                    align: "center",
                    width: 100,
                    value: "no",
                },
                {
                    text: "공지사항",
                    align: "center",
                    value: "notification",
                },
                // {
                //     text: "사이트",
                //     align: "center",
                //     width: 120,
                //     value: "sites",
                // },
                {
                    text: "작성일자",
                    align: "center",
                    width: 120,
                    value: "createdAt",
                },
                {
                    text: "상단고정",
                    align: "center",
                    width: 80,
                    value: "isNotice",
                },
                {
                    text: "Actions",
                    align: "center",
                    width: 100,
                    value: "actions",
                },
            ],
        };
    },
    computed: {
        site() {
            return this.$route.query?.site;
        },
    },
    created() {
        this.init();
    },
    watch: {
        page() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                await this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                var { summary, notifications } = await api.console.center.notifications.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: {
                        sites: this.site,
                    },
                });

                for (let notification of notifications) {
                    notification.createdAt = notification.createdAt.toDateTime();
                    notification.no = (this.page - 1) * this.limit + notifications.indexOf(notification) + 1;
                    console.log({ ...notification });
                }

                this.notifications = notifications;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        async toggleNotice(item) {
            if (this.loading) {
                item.isNotice = !item.isNotice;
                return;
            } else this.loading = true;

            try {
                await api.console.center.notifications.put({ _id: item._id, isNotice: item.isNotice });
            } catch (error) {
                item.isNotice = !item.isNotice;
                console.error(error);
                return;
            } finally {
                this.loading = false;
            }
            await this.search();
        },

        async remove(notification) {
            try {
                if (confirm("공지사항을 삭제하시겠습니까?")) {
                    await api.console.center.notifications.delete(notification);
                    await this.search();
                }
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
    },
};
</script>

<style>
.console-notification .v-data-table__mobile-row {
    height: auto !important;
}
</style>
